<template>
  <div class="animated fadeIn">
    <h3>Tissue Report</h3>
    <b-card v-for="(sample, index) in samples" no-body :key="index">
      <b-card-header>
        <span class="text-muted">
          <b>Sample</b>: {{ sample.number }} | <b>Type</b>: {{ sample.type }} |
          <b>Stage</b>: {{ sample.stage }}
        </span>
      </b-card-header>
      <b-card-body class="p-0">
        <b-table
          class="mb-0"
          :items="sample.analyses"
          :fields="columns"
          responsive
          bordered
        >
          <template #cell(range)="data">
            <report-progress-bar
              :result="data.item.result"
              :low="data.item.range.low"
              :high="data.item.range.high"
            />
          </template>
        </b-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import ReportProgressBar from "@/components/shared/ReportProgressBar";

export default {
  name: "SubmissionTissueReport",
  components: { ReportProgressBar },
  props: {
    samples: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      columns: [
        { key: "name", label: "Analysis" },
        { key: "result", label: "Result" },
        { key: "unit", label: "Units" },
        { key: "range", label: "Tissue Sufficiency Range" },
      ],
    };
  },
};
</script>
